import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=c7d395ba&scoped=true"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"
import style0 from "./Phone.vue?vue&type=style&index=0&id=c7d395ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d395ba",
  null
  
)

export default component.exports